<div class="container">

  <mat-card>
    <div fxLayout="row" fxLayout.lt-md="column">
      <div fxFlex="50%"  >
          <h2 class="homelabel">Empleado: {{staffName?.replace(',','')}}</h2>
      </div>
      <div fxFlex="50%"  >
          <h2 class="homelabel" >Operaciones</h2>
      </div>
    </div>
    <div fxLayout="row"  class="homelabel">
      <form  [formGroup]="tellerSelectorForm">
      <mat-form-field>
        <mat-label>Seleccionar caja</mat-label>
        <mat-select required (selectionChange)="onTellerSelected($event.value)" formControlName="tellerSelectorForm" [compareWith]="compareCategoryObjects">
          <mat-option *ngFor="let teller of tellerList" [value]="teller">
            {{ teller.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <span *ngIf="!tellerSelected" style="color: red;">*Selecciona e inicia una caja para activar operaciones</span>
      </form>
     
    </div>
    <div fxLayout="row" fxLayout.lt-md="column">

      <div fxFlex="50%">

        <mat-nav-list>

          <mat-list-item class="homelist" (click)="onTellerstart()"  id="itemnav" [disabled]="tellerStarted || !tellerSelected">
            <mat-icon matListIcon>
              <fa-icon icon="play" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Iniciar Caja</h4>
            <p matLine translate>Iniciar operaciones de caja</p>
          </mat-list-item>
                    
          <mat-list-item [routerLink]="['/settle-cash']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="forward" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Enviar a bóveda</h4>
            <p matLine translate>Enviar el efectivo recaudado a bóveda</p>
          </mat-list-item>

          <mat-list-item [routerLink]="['/allocate-cash']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="backward" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Recibir de bóveda</h4>
            <p matLine translate>Recibir dinero de la bóveda</p>
          </mat-list-item>

          <mat-list-item [routerLink]="['/cash-difference']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="money-bill" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Faltantantes/Sobrantes</h4>
            <p matLine translate>Ajustar las diferencias en el balance de efectivo</p>
          </mat-list-item>

          <mat-list-item [routerLink]="['/teller-reports']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="file-excel" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Reportes</h4>
            <p matLine translate>Reportes de las operaciones de caja</p>
          </mat-list-item>

          <mat-list-item [routerLink]="['/cotizaciones']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="file-invoice-dollar" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Cotizaciónes</h4>
            <p matLine translate>Obtener cotización</p>
          </mat-list-item>

          <mat-list-item  [routerLink]="['ingresos-egresos-varios','ingreso']"  [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="plus-square" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Ingreso vario</h4>
            <p matLine translate>Ingreso vario</p>
          </mat-list-item>

          <mat-list-item  [routerLink]="['ingresos-egresos-varios','egreso']"  [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="minus-square" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Egreso vario</h4>
            <p matLine translate>Egreso vario</p>
          </mat-list-item>

          <mat-list-item (click)="onTellerClosed()" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="window-close" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Cerrar caja</h4>
            <p matLine translate>Finalizar operaciones de la cja</p>
          </mat-list-item>

        </mat-nav-list>

      </div>

      <div fxFlex="50%">

        <mat-nav-list>
          <mat-list-item [routerLink]="['action','Deposit']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="plus-square" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Depósitos</h4>
            <p matLine translate>Depositar dinero en la cuenta del cliente</p>
          </mat-list-item>

          <mat-list-item [routerLink]="['action','Withdrawal']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="minus-square" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Retiros</h4>
            <p matLine translate>Retirar dinero de la cuenta del cliente</p>
          </mat-list-item>

          <mat-list-item [routerLink]="['forex-transactions','sell']" [disabled]="true">
            <mat-icon matListIcon>
              <fa-icon icon="dollar-sign" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Vender USD</h4>
            <p matLine>Venderle USD al cliente</p>
          </mat-list-item>

          <mat-list-item [routerLink]="['forex-transactions','buy']"  [disabled]="true">
            <mat-icon matListIcon>
              <fa-icon icon="money-bill" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Comprar USD</h4>
            <p matLine tranlsate>Comprarle USD al cliente</p>
          </mat-list-item>

          <mat-list-item [routerLink]="['loans','repayment']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="hand-holding-usd" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Pago de préstamos</h4>
            <p matLine tranlsate>Recibir reembolso a préstamo del cliente</p>
          </mat-list-item>

          <mat-list-item [routerLink]="['loans','foreclosure']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="hand-holding-usd" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Cancelación de préstamos</h4>
            <p matLine tranlsate>Cancelar préstamo del cliente</p>
          </mat-list-item>          

          <mat-list-item [routerLink]="['loans','cancelrepaymentwithcheck']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="hand-holding-usd" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Cancelación de Cheques</h4>
            <p matLine tranlsate>Cancelar Cheque de pago a préstamo (Rechazo)</p>
          </mat-list-item>          

          <mat-list-item [routerLink]="['cashier-transactions']" [disabled]="!tellerStarted">
            <mat-icon matListIcon>
              <fa-icon icon="heartbeat" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine translate>Transacciones del día</h4>
            <p matLine tranlsate>Controle de transacciones para el día de hoy</p>
          </mat-list-item>

        </mat-nav-list>

      </div>

    </div>

  </mat-card>

</div>
